// Galería de portada según la referencia: dos láminas L verticales a los lados y
// seis M verticales en cuadrícula 3×2 al centro. Posiciones en cm (origen = centro).
// Tamaños del catálogo: S 20×15, M 30×40, L 40×60.
const P = {
  calabazas: { src: "/hero/calabazas.jpg", alt: "Calabazas de Halloween", pos: "50% 55%" },
  gato: { src: "/hero/gato.jpg", alt: "Gato", pos: "50% 40%" },
  chrysler: { src: "/hero/chrysler.jpg", alt: "Edificio Chrysler", pos: "50% 30%" },
  garzon: { src: "/hero/garzon.webp", alt: "Plaza de Garzón de noche", pos: "72% 50%" },
  bruja: { src: "/hero/bruja.jpg", alt: "Retrato de Halloween", pos: "50% 30%" },
  perro: { src: "/hero/perro.jpg", alt: "Cachorro", pos: "50% 55%" },
  gaviota: { src: "/hero/gaviota.webp", alt: "Gaviota en vuelo", pos: "58% 50%" },
  espantapajaros: { src: "/hero/espantapajaros.jpg", alt: "Espantapájaros", pos: "50% 35%" },
};

const piece = (photo, size, x, y, w, h) => ({ ...P[photo], id: photo, size, x, y, w, h });

const grid = (ox, oy) => [
  piece("chrysler", "M", ox - 50, oy, 30, 40),
  piece("garzon", "M", ox - 15, oy, 30, 40),
  piece("bruja", "M", ox + 20, oy, 30, 40),
  piece("perro", "M", ox - 50, oy + 45, 30, 40),
  piece("gaviota", "M", ox - 15, oy + 45, 30, 40),
  piece("espantapajaros", "M", ox + 20, oy + 45, 30, 40),
];

export const GALLERY = {
  desktop: {
    bg: "/hero/wall-desktop.jpg", cx: 0.52, cy: 0.35, maxW: 0.74, maxH: 0.56,
    pieces: [
      piece("calabazas", "L", -96, -30, 40, 60),
      ...grid(0, -42.5).slice(0, 3),
      ...grid(0, -42.5).slice(3),
      piece("gato", "L", 56, -30, 40, 60),
    ],
    demoId: "garzon",
  },
  mobile: {
    bg: "/hero/wall-mobile.jpg", cx: 0.54, cy: 0.29, maxW: 0.84, maxH: 0.48,
    pieces: [
      piece("calabazas", "L", -43, -75.5, 40, 60),
      piece("gato", "L", 3, -75.5, 40, 60),
      ...grid(0, -9.5),
    ],
    demoId: "gaviota", liftK: 0.6,
  },
};

export const bounds = (pieces) => {
  const xs = pieces.flatMap((p) => [p.x, p.x + p.w]), ys = pieces.flatMap((p) => [p.y, p.y + p.h]);
  return { x0: Math.min(...xs), y0: Math.min(...ys), x1: Math.max(...xs), y1: Math.max(...ys) };
};
